import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, sortBy } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getPageTotalCount, formatMoneyValue } from '../../../utils/utils';
import TitleFrom from '../../common/TitleFrom';
import AccountHeaderFrom from '../../common/AccountHeaderFrom';
import constant from '../../../containers/CustomerPage/constants';
import { TablePagination, DataTable, ModalDetailsItem, FormCollapse, GenericInput } from '../../common';
import {
  makeGetTransactionUsage,
  makePageTransactionParams,
  makeErrorMessageTU,
} from '../../../containers/CustomerPage/selectors';
import RatedUsageSearchForm from '../RatedUsageSearchForm';
import {
  searchUsageTransaction,
  setTransactionParams,
  getTransactionUnitByIdUsage,
} from '../../../containers/CustomerPage/actions';
import { getConfigUsagePlatforms, getConfigUsageTypeConfig } from '../../../containers/App/actions';

class RatedUsage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      size: 20,
      filter: { accountId: props.id, type: 'USAGE' },
      sort: '',
      sorted: {},
      isSearching: false,
      totalCount: null,
      isOpenModal: false,
      isSearchDataModal: false,
      itemData: {},
      activeTab: {
        // name: 'Recurring Data',
        // isActive: true,
      },
      defaultOptionUsageType: [],
      sourceOptions: [],
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      totalCount: getPageTotalCount({ ...state, items: props.transactionUnit }),
    };
  }

  componentDidMount() {
    const { getConfigUsageTypeConfig, getConfigUsagePlatforms } = this.props;
    this.doSearchTransactions();

    getConfigUsageTypeConfig('', ({ success, data }) => {
      let usageTypeList = [];
      if (success && data && data.configUsageTypeService) {
        data.configUsageTypeService.forEach(val => {
          usageTypeList = [...usageTypeList, ...val.configUsageTypeList];
        });

        const defaultOptionUsageType = usageTypeList.map(val => {
          return { label: val.usagetype, value: val.usagetype };
        });
        this.setState({
          defaultOptionUsageType: defaultOptionUsageType ? sortBy(defaultOptionUsageType, ['label']) : [],
        });
      }
    });

    getConfigUsagePlatforms('', ({ success, data }) => {
      if (success && data?.configUsagePlatformList) {
        const sourceOptions = data.configUsagePlatformList.map(val => ({ label: val.name, value: val.name }));
        this.setState({ sourceOptions: sortBy(sourceOptions, ['label']) });
      }
    });
  }

  doSearchTransactions = () => {
    const { searchUsageTransaction } = this.props;
    const { page, size, filter, sorted } = this.state;
    this.setState({ isSearching: true });
    searchUsageTransaction(
      {
        page: page + 1,
        size,
        filter,
        sort: !isEmpty(sorted) ? constant.ratedUsageSort[sorted.sortCol][sorted.sortDir] : null,
      },
      () => this.setState({ isSearching: false })
    );
  };

  onHandleSubmit = filter => {
    const { id } = this.props;
    const newFilter = filter;
    newFilter.accountId = id;
    newFilter.type = 'USAGE';
    this.setState({ filter: newFilter }, () => this.doSearchTransactions());
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => this.doSearchTransactions());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchTransactions());
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchTransactions());
  };

  onToggleModal = () => {
    const { isOpenModal } = this.state;
    this.setState({ isOpenModal: !isOpenModal });
  };

  doGetTransactionById = id => {
    const { getTransactionUnitByIdUsage } = this.props;
    this.setState({ isOpenModal: true, isSearchDataModal: true });
    getTransactionUnitByIdUsage(id, ({ data, success }) =>
      this.setState({ itemData: success ? data : {}, isSearchDataModal: false })
    );
  };

  onToggleTab = activeTabName => {
    const { activeTab } = this.state;
    if (activeTab.name === activeTabName) {
      this.setState({
        activeTab: { name: activeTabName, isActive: !activeTab.isActive },
      });
    } else {
      this.setState({ activeTab: { name: activeTabName, isActive: true } });
    }
  };

  renderItem = item => {
    const { itemData } = this.state;
    switch (item.state) {
      case 'Recurring Data':
        return (
          <div className="row col-md-12 p-2">
            {constant.dataFieldRecurringByTransactionId.map(val => (
              <GenericInput
                key={val.name}
                value={
                  itemData.recurringData && itemData.recurringData[0] && itemData.recurringData[0][val.name]
                    ? itemData.recurringData[0][val.name]
                    : null
                }
                disabled
                onChange={() => {}}
                {...val}
              />
            ))}
          </div>
        );
      case 'Usage Data':
        return (
          <div className="row col-md-12 p-2">
            {constant.dataFieldUsageTransactionId.map(val => (
              <GenericInput
                key={val.name}
                value={
                  itemData.txnUsageData && itemData.txnUsageData && itemData.txnUsageData[val.name]
                    ? val.isNumberFormat
                      ? formatMoneyValue(itemData.txnUsageData[val.name])
                      : itemData.txnUsageData[val.name]
                    : null
                }
                disabled
                onChange={() => {}}
                {...val}
              />
            ))}
          </div>
        );
      case 'Tax Data':
        return (
          <div className="col-md-12">
            <DataTable columns={constant.tableTaxDataByTransactionId} data={itemData.taxData ? itemData.taxData : []} />
          </div>
        );
      case 'Currency':
        return (
          <div className="col-md-12">
            <DataTable
              columns={constant.tableCurrencyTransactionById}
              data={itemData.balances ? itemData.balances : []}
            />
          </div>
        );
      case 'Grants':
        return (
          <div className="col-md-12">
            <DataTable
              columns={constant.tableGrantsByTransactionId}
              data={itemData.txnGrants ? itemData.txnGrants : []}
            />
          </div>
        );
      case 'Accumulator':
        return (
          <div className="col-md-12">
            <DataTable
              columns={constant.tableAccumulatorByTransactionId}
              data={itemData.txnAccumulators ? itemData.txnAccumulators : []}
            />
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const { transactionUnit, id, t, currencyOptions, customerInfo } = this.props;
    const {
      isSearching,
      sorted,
      page,
      size,
      totalCount,
      isOpenModal,
      itemData,
      isSearchDataModal,
      activeTab,
      defaultOptionUsageType,
      sourceOptions,
    } = this.state;

    let newCollapsibleMenu = constant.collapsibleMenuTransactionId;

    if (!itemData.type || ['FORWARD_RECURRING', 'ARREARS_RECURRING'].indexOf(itemData.type) === -1)
      newCollapsibleMenu = newCollapsibleMenu.filter(val => val.state !== 'Recurring Data');
    if (!itemData.type || itemData.type !== 'USAGE')
      newCollapsibleMenu = newCollapsibleMenu.filter(val => val.state !== 'Usage Data');
    if (!itemData.type || itemData.type !== 'TAX')
      newCollapsibleMenu = newCollapsibleMenu.filter(val => val.state !== 'Tax Data');
    if (!itemData.balances || !itemData.balances.length)
      newCollapsibleMenu = newCollapsibleMenu.filter(val => val.state !== 'Currency');
    if (!itemData.txnGrants || !itemData.txnGrants.length)
      newCollapsibleMenu = newCollapsibleMenu.filter(val => val.state !== 'Grants');
    if (!itemData.txnAccumulators || !itemData.txnAccumulators.length)
      newCollapsibleMenu = newCollapsibleMenu.filter(val => val.state !== 'Accumulator');

    const columns = constant.ratedUsageTransactions.billsTable;
    const newColumns = [
      {
        name: 'id',
        label: 'label.id',
        render: (colName, item) => (
          <button type="button" className="text-success no-border" onClick={() => this.doGetTransactionById(item.id)}>
            {item.id}
          </button>
        ),
      },
      ...columns,
      {
        name: 'select',
        label: '',
        render: (colName, item) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={() => this.doGetTransactionById(item.id)}
          >
            {t('label.view')}
          </button>
        ),
      },
    ];
    let currencyLabel = '';
    if (currencyOptions && currencyOptions.length && customerInfo?.currency) {
      const currencySelect = currencyOptions.find(val => val.value === customerInfo?.currency);
      currencyLabel = currencySelect ? currencySelect.normalLabel : '';
    }
    return (
      <div className="col-md-12 mb-30">
        <div className="card card-statistics">
          <TitleFrom title={t('label.ratedUsageTransactions')} />
          <AccountHeaderFrom
            accountNum={id}
            commercialName={customerInfo?.commercialName || ''}
            isCommercialName={customerInfo?.customerSegment !== 'B2C'}
            currencyLabel={currencyLabel ? `(${currencyLabel})` : ''}
          />
          <div className="card-body">
            <RatedUsageSearchForm
              onSubmit={this.onHandleSubmit}
              isMultipleOptionInject
              optionsInject={{
                usageType: defaultOptionUsageType,
                sourceSystem: sourceOptions,
              }}
            />
            <br />
            <div>
              <DataTable
                columns={newColumns}
                data={transactionUnit}
                isLoading={isSearching}
                sorted={sorted}
                onSort={this.onSortColumn}
              />
            </div>
          </div>
        </div>
        <br />
        <div className="col-sm-12 mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalDetailsItem
          isOpen={isOpenModal}
          data={itemData}
          onToggle={this.onToggleModal}
          dataField={constant.dataFieldTransactionById}
          title={t('label.transactions')}
          isSearch={isSearchDataModal}
          wrapperClass="modal-custom modal-70 bd-example-modal-lg"
          isBackBtn
        >
          <div className="pt-4">
            {newCollapsibleMenu.map(item => (
              <FormCollapse
                key={item.title}
                label="First Name"
                isActive={item.state === activeTab.name && activeTab.isActive}
                title={t(item.title) || ''}
                state={item.state}
                onToggleTab={this.onToggleTab}
              >
                {this.renderItem(item)}
              </FormCollapse>
            ))}
          </div>
        </ModalDetailsItem>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  transactionUnit: makeGetTransactionUsage() || [],
  params: makePageTransactionParams() || {},
  errorMessage: makeErrorMessageTU() || '',
});

RatedUsage.propTypes = {
  transactionUnit: PropTypes.arrayOf(PropTypes.any),
  getTransactionUnit: PropTypes.func.isRequired,
  id: PropTypes.string,
};

RatedUsage.defaultProps = {
  id: '',
  transactionUnit: [],
};

const newRatedUsage = connect(mapStateToProps, {
  searchUsageTransaction,
  setTransactionParams,
  getTransactionUnitByIdUsage,
  getConfigUsagePlatforms,
  getConfigUsageTypeConfig,
})(RatedUsage);

export default withTranslation('common')(newRatedUsage);
